import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { getDomains } from "../../core/repo/domainRepo";
import { usePostHog } from "posthog-js/react";
import {
  getAccountDetails,
  getSelectedFilesLocalStorage,
  getUserDetails,
} from "../../core/storage/localStorage";
import { getUserAndAccount } from "../../core/repo/accountRepo";
import useIsMounted from "../../hooks/useIsMounted";
import {
  setSelectedFilesSuccess,
  getSessionsSuccess,
  getSessionMessagesSuccess,
} from "../../core/events/sessionEvents";
import SplashScreen from "../../components/SplashScreen";
import { useThemeSettings } from "../../theme/ThemeSettingsProvider";
import { setPidTabsSuccess } from "../../core/events/pidEvents";
import { getPidTabsLocalStorage } from "../../core/storage/localStorage";

function DashboardLayout({ children }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const account = getAccountDetails();
  const user = getUserDetails();
  const isMountedRef = useIsMounted();
  const [isLoading, setIsLoading] = useState(true);
  const { selectedDomain } = useSelector((state) => state.domain);
  const { setMode } = useThemeSettings();

  async function fetchData() {
    setIsLoading(true);
    try {
      dispatch(getSessionsSuccess([]));
      dispatch(getSessionMessagesSuccess([]));
      await dispatch(getUserAndAccount());
      await dispatch(getDomains());
      dispatch(setSelectedFilesSuccess(getSelectedFilesLocalStorage()));
      dispatch(setPidTabsSuccess(getPidTabsLocalStorage()));
    } catch (e) {
      console.log(e);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
    if (account?.name === "Indorama RFP") {
      setMode("dark");
    }
    if (account && user)
      posthog.identify(user["id"], {
        email: user["email"],
        account_id: account["id"],
        account_name: account["name"],
        name: user["name"],
        role: user["role"],
        plant: user["plant"],
        line: user["line"],
        access_domains: user["access_domains"]
          ? user["access_domains"]["domains"]
          : [],
      });
  }, [isMountedRef]);

  return isLoading || !selectedDomain ? (
    <SplashScreen />
  ) : (
    <Box
      display={"flex"}
      flexDirection={"column"}
      width={"100vw"}
      sx={{ height: "100vh", height: "100svh" }}
      bgcolor={theme.palette.background.dark}>
      <Box flex={1} overflow={"hidden"} display={"flex"} flexDirection={"row"}>
        <Sidebar />
        <Box sx={{ flex: 1, overflow: "auto" }} p={1} pl={0}>
          <Box
            overflow={"hidden"}
            bgcolor={theme.palette.background.default}
            border={`1px solid ${theme.palette.divider}`}
            height={"100%"}
            width={"100%"}
            borderRadius={6}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardLayout;
